import { TextButton } from '@oneaudi/unified-web-components';
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { addSearchParams } from '@oneaudi/feature-app-utils';
import { FAStateContext } from '../context/FAStateContext';
import { UniversalStateContext } from '../context/UniversalStateContext';
import { useTrackingManager } from '../hooks/useTracking';
import { getRelatedProductInformation } from '../utils/trackingUtils';
import { ContentContext } from '../context/ContentContext';

export const ConfigureButton = () => {
  const { i18nTexts } = useContext(UniversalStateContext)!;
  const trackingManager = useTrackingManager();
  const { carline } = useContext(FAStateContext);

  const {
    carline: { configuratorLink },
    idString,
    colorState: [color],
    rimState: [rim],
  } = useContext(FAStateContext);
  const { carlineId } = useContext(ContentContext);

  const linkWithParams = useMemo(() => {
    if (!configuratorLink) {
      return null;
    }

    if (!idString) {
      return configuratorLink;
    }
    return addSearchParams(configuratorLink, new Map([['pr', idString]]));
  }, [idString]);

  if (!linkWithParams) {
    return null;
  }

  const trackCTA = () => {
    const relatedProductInfo = getRelatedProductInformation(carline, [color, rim]);
    trackingManager.click({
      eventAction: 'internal_link', // todo check if internal or external
      eventName: "click on 'continue with configuration'",
      elementName: 'button',
      value: carlineId,
      targetURL: configuratorLink,
      relatedProducts: relatedProductInfo,
      label: i18nTexts.configureLinkText,
    });
  };
  const buttonSize = process.env.IS_LEGACY ? 'md' : 'sm';
  return (
    <StyledTextButton variant="primary" href={linkWithParams} onClick={trackCTA} size={buttonSize}>
      {i18nTexts.configureLinkText}
    </StyledTextButton>
  );
};

const StyledTextButton = styled(TextButton)`
  width: 100%;
  @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
    width: auto;
  }
`;
